(function () {
  var body = document.querySelector('[data-mp-blog-body]');
  if (!body) return;

  var titleEl = document.querySelector('.mp-blog-post__title');
  var titleText = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  var metaLine = /^(published|last updated|reading time|category)\b/i;
  var introLine = /^(real hobby advice from mp sports cards|behind the counter real hobby advice)/i;
  var stopHeading = /^(continue your journey|continue reading|about behind the counter)$/i;

  Array.prototype.slice.call(body.children).forEach(function (el) {
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) {
      el.parentNode.removeChild(el);
      return;
    }
    if (el.matches('h1') && titleText && text.toLowerCase() === titleText) {
      el.parentNode.removeChild(el);
    }
  });

  Array.prototype.slice.call(body.children).forEach(function (el) {
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (metaLine.test(text) && text.length < 80) {
      el.parentNode.removeChild(el);
      return;
    }
    if (introLine.test(text) && text.length < 80) {
      el.parentNode.removeChild(el);
    }
  });

  var cutting = false;
  Array.prototype.slice.call(body.children).forEach(function (el) {
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (stopHeading.test(text)) cutting = true;
    if (cutting) el.parentNode.removeChild(el);
  });
})();
